'use client';

import { PageHeader } from '@slims/ui/templates';
import { Outlet, useLocation } from 'react-router-dom';
import { AdminTabBar } from '@/components/layout/admin-tab-bar';
import { ConfigSwitcher } from '@/components/onboarding/config-switcher';
import { useAdminScopeStore } from '@/stores/admin-scope-store';

export default function MembersLayout() {
	// On the single-member detail page the page provides its own header, so the
	// list chrome (title, subtitle, CER/configuration switcher) is redundant.
	const isDetail = useLocation().pathname.includes('/details');
	// Senza configurazione il registro non ha dove leggere né scrivere: resta
	// solo l'avviso del ConfigSwitcher.
	const hasConfig = useAdminScopeStore((s) => s.configId) !== null;

	return (
		<div>
			<AdminTabBar />
			{!isDetail && (
				<>
					<PageHeader size="display" title="Soci" />
					<ConfigSwitcher />
				</>
			)}
			{(isDetail || hasConfig) && <Outlet />}
		</div>
	);
}
